/* global PIXI TimelineMax */
import React, { Component } from 'react';
import ReactScene from 'react-scene';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { loadTextures, clearTextures } from '../../lib/loadTextures';
import Scene from '../views/Scene.jsx';

// Scene data
import IntroObjects from '../../objects/intro';

// Frames
import Title from '../frames/0-Intro/1-Title.jsx';
import LeonSpeech from '../frames/0-Intro/2-LeonSpeech.jsx';
import Machine from '../frames/0-Intro/3-Machine.jsx';

import Family from '../frames/0-Intro/41-Family.jsx';
import Dave from '../frames/0-Intro/42-Dave.jsx';
import Brett from '../frames/0-Intro/43-Brett.jsx';
import Analysis from '../frames/0-Intro/44-Analysis.jsx';
import Ministre from '../frames/0-Intro/45-Ministre.jsx';

import EndMachine from '../frames/0-Intro/5-EndMachine.jsx';

const propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    skipIntro: PropTypes.bool,

    frameWidth: PropTypes.number,
    frameHeight: PropTypes.number,

    storiesContainer: PropTypes.object,

    mouseDown: PropTypes.bool,
    mouseMove: PropTypes.bool,
    mouseClientX: PropTypes.number,
    mouseClientY: PropTypes.number,
    mouseWheelX: PropTypes.number,
    mouseWheelY: PropTypes.number,
};

const defaultProps = {
    preventConclusion: true,
    framesClasses: [
        Title, LeonSpeech, Machine, Family, Dave, Brett, Analysis, Ministre, EndMachine,
    ],
    framesRenderExceptions: {},
    // ambiancesUrls: {
    //     intensity1: '/audio/30nov/ambiance-niveau-02-30nov.mp3',
    //     intensity2: '/audio/30nov/ambiance-niveau-03-30nov.mp3',
    //     intensity3: '/audio/30nov/ambiance-niveau-04-30nov.mp3',
    //     crisis: '/audio/30nov/ambiance-niveau-05-30nov.mp3',
    // },
};

const contextTypes = {
    intensity: React.PropTypes.number,
};

class Intro extends Component {

    constructor(props) {
        super(props);
        this.sprites = null;
        this.mainTimeline = null;

        this.load = this.load.bind(this);
        this.build = this.build.bind(this);

        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);

        this.onTextureLoaded = this.onTextureLoaded.bind(this);

        this.state = {
            objectsWithTextures: null,
            mainContainer: null,
            loadedProgress: 0,
        };
    }

    /*
     * React life cycle
     */

    componentDidMount() {
        this.mainTimeline = new TimelineMax({
            paused: true,
        });
    }

    componentWillUnmount() {
        if (this.mainTimeline) {
            this.mainTimeline.pause();
            this.mainTimeline.kill();
            this.mainTimeline = null;
        }
    }

    resize(e) {

    }

    mute(e) {

    }

    unmute(e) {

    }

    play(e) {
        if (this.mainTimeline) {
            this.mainTimeline.play();
        }
    }

    pause(e) {
        if (this.mainTimeline) {
            this.mainTimeline.pause();
        }
    }

    end(e) {

    }

    destroy(e) {

    }

    /*
     * Methods
     */

    buildObjects() {

        /* const props = this.props;
        const state = this.state;
        const sprites = this.sprites;
        const mainContainer = state.mainContainer;
        const objs = state.objectsWithTextures;

        const width = props.frameWidth;
        const height = props.frameHeight;
        const border = props.frameBorder; */
    }

    animateObjects() {

    }

    /*
     * Event handlers
     */

    onTextureLoaded(data) {
        this.setState({
            loadedProgress: data.progress,
        });
    }

    /*
     * Scene life cycle
     */

    build() {
        const mainContainer = new PIXI.Container();
        this.props.storiesContainer.addChild(mainContainer);
        this.sprites = {};

        this.setState({
            mainContainer,
        }, () => {
            this.buildObjects();
            this.animateObjects();
        });
    }

    load(e) {
        const done = e.async();

        const onTexturesLoaded = (objectsWithTextures) => {
            this.setState({
                objectsWithTextures,
            }, done);
        };

        // console.log('re-load intro');

        clearTextures(Object.keys(IntroObjects));

        loadTextures(IntroObjects, this.onTextureLoaded)
            .then(onTexturesLoaded);
    }

    render() {
        const props = this.props;
        const state = this.state;
        const context = this.context;

        const newProps = _.merge(_.omit(props, ['frameIndex']), {
            frameIndex: 0,
        });

        return (
            <Scene
                intensity={context.intensity}
                showIntensitySelector={false}
                showBackButton={false}
                mainContainer={state.mainContainer}
                objectsWithTextures={state.objectsWithTextures}
                loadedProgress={state.loadedProgress}
                initialMessageBoxPlaying={false}
                {...newProps}
            />
        );
    }
}

Intro.propTypes = propTypes;
Intro.defaultProps = defaultProps;
Intro.contextTypes = contextTypes;

module.exports = ReactScene.createScene(Intro);



// WEBPACK FOOTER //
// ./js/components/scenes/0-Intro.jsx